import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import { GridButton, Placeholder, GridIconFab } from '../Form/shared';
import { FormBlock, FormTextField } from '../Form';
import styles from './styles';
import withDeletePopup from '../withDeletePopup';

const initialOffloadValue = {
  pax: {
    weight: null,
    pkgs: null,
    name: null,
    reason: null,
  },
  cargo: {
    weight: null,
    pkgs: null,
    awbNumber: null,
    reason: null,
  },
  baggage: {
    weight: null,
    pkgs: null,
    tag: null,
    reason: null,
  },
};

class Offload extends Component {
  handleAddClick = type => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      `outbound.offload.${type}[${values.outbound.offload[type].length}]`,
      initialOffloadValue[type]
    );
  };

  handleDeleteClick = (type, index) => {
    const { setFieldValue, values } = this.props;
    setFieldValue(`outbound.offload.${type}`, [
      ...values.outbound.offload[type].slice(0, index),
      ...values.outbound.offload[type].slice(index + 1),
    ]);
  };

  render() {
    const { classes, values, onDeleteConfirmationDialogOpen, t } = this.props;
    const { offload } = values.outbound;
    return (
      <>
        {t('Pax')}
        {offload.pax.map((p, i) => (
          <FormBlock key={`offloadPax${i}`}>
            <FormTextField
              fullWidth
              name={`outbound.offload.pax[${i}].name`}
              label={t('Name')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.pax[${i}].pkgs`}
              label={t('PC')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.pax[${i}].weight`}
              label={t('WT')}
            />
            <FormTextField
              fullWidth
              name={`outbound.offload.pax[${i}].reason`}
              label={t('Reason')}
            />
            <GridIconFab
              color="secondary"
              className={classes.withTopSpacer}
              xs={12}
              icon="delete"
              onClick={() =>
                onDeleteConfirmationDialogOpen(
                  this.handleDeleteClick.bind(null, 'pax', i)
                )
              }
            />
          </FormBlock>
        ))}
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            variant="contained"
            color="primary"
            xs={3}
            label={t('ADD')}
            onClick={this.handleAddClick.bind(null, 'pax')}
          />
        </FormBlock>
        {t('Cargo')}
        {offload.cargo.map((c, i) => (
          <FormBlock key={`offloadCargo${i}`}>
            <FormTextField
              fullWidth
              name={`outbound.offload.cargo[${i}].awbNumber`}
              label={t('AWB_no.')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.cargo[${i}].pkgs`}
              label={t('PC')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.cargo[${i}].weight`}
              label={t('WT')}
            />
            <FormTextField
              fullWidth
              name={`outbound.offload.cargo[${i}].reason`}
              label={t('Reason')}
            />
            <GridIconFab
              color="secondary"
              className={classes.withTopSpacer}
              xs={12}
              icon="delete"
              onClick={() =>
                onDeleteConfirmationDialogOpen(
                  this.handleDeleteClick.bind(null, 'cargo', i)
                )
              }
            />
          </FormBlock>
        ))}
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            variant="contained"
            color="primary"
            xs={3}
            label={t('ADD')}
            onClick={this.handleAddClick.bind(null, 'cargo')}
          />
        </FormBlock>
        {t('Baggage')}
        {offload.baggage.map((b, i) => (
          <FormBlock key={`offloadCargo${i}`}>
            <FormTextField
              fullWidth
              name={`outbound.offload.baggage[${i}].tag`}
              label={t('Tags_no.')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.baggage[${i}].pkgs`}
              label={t('PC')}
            />
            <FormTextField
              size={6}
              name={`outbound.offload.baggage[${i}].weight`}
              label={t('WT')}
            />

            <FormTextField
              fullWidth
              name={`outbound.offload.baggage[${i}].reason`}
              label={t('Reason')}
            />
            <GridIconFab
              color="secondary"
              className={classes.withTopSpacer}
              xs={12}
              icon="delete"
              onClick={() =>
                onDeleteConfirmationDialogOpen(
                  this.handleDeleteClick.bind(null, 'baggage', i)
                )
              }
            />
          </FormBlock>
        ))}
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            variant="contained"
            color="primary"
            xs={3}
            label={t('ADD')}
            onClick={this.handleAddClick.bind(null, 'baggage')}
          />
        </FormBlock>
      </>
    );
  }
}

export default withTranslation()(withStyles(styles)(withDeletePopup(Offload)));
